export default function getMinAmount(field) {
  const minAmount = parseFloat(field.dataset.minAmount)
  return isNaN(minAmount) ? 0.01 : minAmount
}
